import { forwardRef, type InputHTMLAttributes } from "react";

type PennInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

export const PennInput = forwardRef<HTMLInputElement, PennInputProps>(
  ({ error = false, className = "", ...props }, ref) => {
    const inactive = !!props.readOnly || !!props.disabled;
    return (
      <input
        ref={ref}
        {...props}
        className={[
          "w-full px-4 py-3 rounded-xl border text-sm text-penn-text placeholder-gray-400 outline-none transition disabled:opacity-50 disabled:cursor-not-allowed focus:border-penn-500  focus:ring-penn-300",
          error
            ? "border-error bg-error/5"
            : inactive
              ? "border-gray-200 bg-gray-100"
              : "border-gray-200 bg-white hover:border-penn-500",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      />
    );
  },
);

PennInput.displayName = "PennInput";
